import { Select as BUSelect, SelectOverrides } from 'baseui/select'
import { ExtendedTheme, styled } from 'parkdepot-shared/theme'
import React, { ComponentProps } from 'react'
import SelectArrow from './SelectArrow'
import { SelectControlContainer, SelectDropdown, SelectDropdownListItem, SelectPlaceholder, SelectRoot } from './styled'

export type BaseSelectProps = ComponentProps<typeof BUSelect>

export const BaseSelect = ({ overrides, ...props }: BaseSelectProps) => {
    const defaultOverrides: SelectOverrides = {
        ...overrides,
        Root: { component: SelectRoot, ...overrides?.Root },
        Dropdown: { component: SelectDropdown, ...overrides?.Dropdown },
        ControlContainer: { component: SelectControlContainer, ...overrides?.ControlContainer },
        DropdownListItem: { component: SelectDropdownListItem, ...overrides?.DropdownListItem },
        SelectArrow: { component: SelectArrow, ...overrides?.SelectArrow },
        Placeholder: { component: SelectPlaceholder, ...overrides?.Placeholder }
    }

    return <BUSelect overrides={defaultOverrides} {...props} />
}

BaseSelect.Option = styled<'div', { $isSelected?: boolean }, ExtendedTheme>('div', ({ $isSelected, $theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: $theme.sizing.scale300,
    color: $isSelected ? $theme.colors.primary : $theme.colors.black
}))
